module.exports = __webpack_public_path__ + "img/Banner640Event.24386d44.png";